export default async ({ store, $auth }) => {
    await store.dispatch('auth/initAuth', $auth);
}